export default __webpack_public_path__ + "static/media/aim.d83854f1.svg";